var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-button",
        {
          attrs: { type: "info", size: "mini" },
          on: { click: _vm.getAnReply },
        },
        [_vm._v(" 查看 ")]
      ),
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.dialogLoading,
              expression: "dialogLoading",
            },
          ],
          staticStyle: { height: "100%" },
          attrs: {
            "append-to-body": "",
            title: _vm.opinionSurveyTopics.title,
            visible: _vm.dialogVisible,
            width: "60%",
            top: "1%",
            "data-role": "drag-drop-container",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                padding: "20px",
                "padding-bottom": "0",
                height: "100%",
              },
            },
            [
              _c("el-alert", {
                staticStyle: { margin: "5px" },
                attrs: {
                  title: _vm.ansSurveyTopics.userName,
                  type: "success",
                  description: "填寫時間：" + _vm.ansSurveyTopics.replyDate,
                  "show-icon": "",
                  closable: false,
                },
              }),
              _c(
                "el-tag",
                { staticStyle: { position: "absolute", top: "0", left: "0" } },
                [
                  _c("count-to", {
                    staticClass: "card-panel-num",
                    attrs: {
                      "start-val": 0,
                      "end-val": _vm.ansSurveyTopics.point,
                      duration: 4600,
                    },
                  }),
                  _vm._v("/ " + _vm._s(_vm.ansSurveyTopics.totalPoint)),
                ],
                1
              ),
              _c(
                "el-input",
                {
                  attrs: { placeholder: "請輸入表單標題", disabled: "" },
                  model: {
                    value: _vm.ansSurveyTopics.title,
                    callback: function ($$v) {
                      _vm.$set(_vm.ansSurveyTopics, "title", $$v)
                    },
                    expression: "ansSurveyTopics.title",
                  },
                },
                [_c("template", { slot: "prepend" }, [_vm._v("表單標題")])],
                2
              ),
              _c(
                "el-form",
                { attrs: { inline: false } },
                [
                  _vm._l(_vm.ansSurveyTopics.topicList, function (item, index) {
                    return [
                      _c(
                        "el-form-item",
                        { key: index },
                        [
                          [
                            item.required
                              ? _c(
                                  "el-tag",
                                  { attrs: { type: "info", size: "mini" } },
                                  [_vm._v("必填")]
                                )
                              : _c(
                                  "el-tag",
                                  { attrs: { type: "info", size: "mini" } },
                                  [_vm._v("非必填")]
                                ),
                            _vm._v(" " + _vm._s(index + 1) + "， "),
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  "font-size": "12px",
                                  color: "chocolate",
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    item.topicType == 1 ? "單選題" : "簡答題"
                                  )
                                ),
                              ]
                            ),
                            !item.isDefault
                              ? _c("el-switch", {
                                  staticStyle: { "margin-left": "5px" },
                                  attrs: {
                                    disabled: item.hasAns,
                                    "active-text": "必填",
                                    "inactive-text": "非必填",
                                  },
                                  model: {
                                    value: item.required,
                                    callback: function ($$v) {
                                      _vm.$set(item, "required", $$v)
                                    },
                                    expression: "item.required",
                                  },
                                })
                              : _vm._e(),
                            _c("el-input", {
                              attrs: {
                                disabled: item.isDefault || item.hasAns,
                                size: "mini",
                              },
                              model: {
                                value: item.topicDescription,
                                callback: function ($$v) {
                                  _vm.$set(item, "topicDescription", $$v)
                                },
                                expression: "item.topicDescription",
                              },
                            }),
                            item.topicType == 1
                              ? [
                                  item.topicCustomAnswer == 0
                                    ? [
                                        _vm._l(
                                          item.options,
                                          function (op, opIndex) {
                                            return [
                                              op.isSelected
                                                ? _c(
                                                    "el-tag",
                                                    {
                                                      key: opIndex,
                                                      staticStyle: {
                                                        margin: "3px",
                                                        "font-size": "16px",
                                                        border:
                                                          "1px solid blue",
                                                      },
                                                      attrs: {
                                                        type: "success",
                                                        size: "medium",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          op.optionDescription
                                                        )
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              !op.isSelected
                                                ? _c(
                                                    "el-tag",
                                                    {
                                                      key: opIndex,
                                                      staticStyle: {
                                                        margin: "3px",
                                                      },
                                                      attrs: {
                                                        size: "mini",
                                                        type: "info",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          op.optionDescription
                                                        )
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          }
                                        ),
                                      ]
                                    : _vm._e(),
                                ]
                              : _vm._e(),
                            item.topicType == 2
                              ? [
                                  _c(
                                    "div",
                                    { staticClass: "ans-text" },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          disabled: "",
                                          value: item.ansText,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              : _vm._e(),
                          ],
                        ],
                        2
                      ),
                    ]
                  }),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "danger" },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("關 閉")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }